module.exports = __webpack_public_path__ + "static/1-f998f27f8b5a0be7902ec61b80bb09d7.jpeg";